import PropTypes from 'prop-types';
import React from 'react';

import { EmitMetric } from '../../../Analytics/VisibilityPixel/VisibilityPixel';
import GroupLogo from '../../../Groups/GroupLogo/GroupLogo';
import { GroupCondensedPropShape } from '../../../Includes/GroupPropsShape';

import './GroupLayout.scss';

export default class GroupLayout extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        group: PropTypes.shape(GroupCondensedPropShape),
    };

    handleMetrics = () => {
        EmitMetric({
            misc_event_type: 'group-hover-click',
            misc_event_count: 1,
            community_group_hash: this.props.group.hash,
            user_id: this.props.userId,
        });
    };

    getPrivacyText = (type) => {
        if (type === 'closed') {
            return 'closed group';
        }

        if (type === 'secret') {
            return 'secret group';
        }

        return 'public group';
    };

    renderContent = () => {
        const { group } = this.props;
        const { name, logo, description, privacySetting } = group;

        return (
            <div className="group-layout-main-content">
                <div className="logo-container">
                    <GroupLogo
                        logo={logo}
                        name={name}
                        isAdmin={false}
                        iconSize="xMedium"
                    />
                </div>
                <div className="group-information">
                    <div className="group-title">{name}</div>
                    <div className="group-privacy">
                        {this.getPrivacyText(privacySetting)}
                    </div>
                    <div className="group-description">{description}</div>
                </div>
            </div>
        );
    };

    render() {
        const {
            group: { groupUrl },
        } = this.props;

        return (
            <div className="component-CallToAction-HoverCallToAction-GroupLayout">
                {this.renderContent()}

                <div className="group-detail">
                    <div
                        className="view-group-btn"
                        onClick={this.handleMetrics}
                    >
                        <a href={groupUrl}>View group</a>
                    </div>
                </div>
            </div>
        );
    }
}
